import { DependencyInjectionContainer } from "./dependency-injection-container";
import { OurNodeset } from "../poc/our-nodeset";

const machineStructureNodesetKey = "machineStructureNodeset";

export const getMachineStructureNodeset = () => {
  return DependencyInjectionContainer.getInstance().resolve<OurNodeset>(
    machineStructureNodesetKey,
  );
};

export const registerMachineStructureNodeset = () => {
  DependencyInjectionContainer.getInstance().register(
    machineStructureNodesetKey,
    OurNodeset,
  );
};
